var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMail3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10158_5016)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10158_5016",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V24H30V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10158_5016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5072 15.5425C16.7608 16.0631 15.8938 16.3382 15 16.3382C14.1062 16.3382 13.2393 16.0631 12.4929 15.5425L0.199746 6.96853C0.131543 6.92097 0.0650977 6.87137 0 6.82037V20.8697C0 22.4805 1.24951 23.7589 2.7617 23.7589H27.2382C28.778 23.7589 29.9999 22.4517 29.9999 20.8697V6.82031C29.9347 6.87144 29.8682 6.92115 29.7998 6.96878L17.5072 15.5425Z",
    fill: "#673ee5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1748 5.43533L13.4679 14.0093C13.9333 14.3339 14.4666 14.4961 14.9999 14.4961C15.5333 14.4961 16.0667 14.3338 16.5321 14.0093L28.8252 5.43533C29.5608 4.92257 30 4.0644 30 3.13818C30 1.5456 28.7615 0.25 27.2392 0.25H2.76076C1.2385 0.250062 0 1.54566 0 3.13971C0 4.0644 0.439219 4.92257 1.1748 5.43533Z",
    fill: "#673ee5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10158_5016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail3);
export default __webpack_public_path__ + "static/media/icon_mail_3.b0bcd323d4103277f89211399bf65803.svg";
export { ForwardRef as ReactComponent };